
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 18 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.587 2.545h-5.54V1.488h5.54v1.057zm5.241 0h-3.636V.743c0-.41-.358-.743-.803-.743H5.242c-.443 0-.803.333-.803.743v1.802H.803c-.445 0-.803.333-.803.743s.358.744.803.744h16.025c.445 0 .805-.334.805-.744s-.36-.743-.805-.743zm-1.782 2.317c-.443 0-.803.333-.803.743v11.258c0 .302-.264.547-.59.547H3.98c-.326 0-.59-.245-.59-.547V5.605c0-.41-.36-.743-.803-.743-.445 0-.805.333-.805.743v11.258c0 1.122.986 2.035 2.198 2.035h9.671c1.213 0 2.198-.913 2.198-2.035V5.605c0-.41-.36-.743-.803-.743zM7.79 14.927V5.605c0-.41-.36-.743-.803-.743-.443 0-.803.333-.803.743v9.322c0 .41.36.743.803.743.443 0 .803-.333.803-.743zm3.66 0V5.605c0-.41-.36-.743-.804-.743-.443 0-.803.333-.803.743v9.322c0 .41.36.743.803.743.445 0 .805-.333.805-.743z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/delete.svg